var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0526,
    cy: 14.0526,
    r: 14.0526,
    fill: "#263238"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02269 10.7067C6.02269 10.5626 6.04548 10.4237 6.08767 10.2936L12.3392 15.5032C13.3318 16.3304 14.7737 16.3304 15.7663 15.5032L22.0179 10.2936C22.06 10.4237 22.0828 10.5626 22.0828 10.7067V18.7368C22.0828 19.476 21.4836 20.0752 20.7445 20.0752H7.36103C6.62189 20.0752 6.02269 19.476 6.02269 18.7368V10.7067ZM21.0067 9.39407L14.9096 14.4751C14.4132 14.8887 13.6923 14.8887 13.196 14.4751L7.09879 9.39407C7.18359 9.37723 7.27128 9.36839 7.36103 9.36839H20.7445C20.8342 9.36839 20.9219 9.37723 21.0067 9.39407Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 1.33835
  })));
};
export default __webpack_public_path__ + "static/media/message-in-app.bc34783a.svg";
export { SvgComponent as ReactComponent };